import SuggestionsDropdown from '@finn-no/suggestions-dropdown';
import el from '@finn-no/create-element';
import tracking from '@finn-no/analytics';

export default function search (form, streamingSuggestUrl, suggestUrl, client) {
    const isGlobal = form.hasAttribute('data-global');
    const isDropdown = form.hasAttribute('data-is-dropdown');
    const where = form.getAttribute('data-where');
    const beta = form.getAttribute('data-beta');
    const searchKeys = form.getAttribute('data-search-keys') || '';
    const spinnerEle = form.querySelector('[data-spinner]');
    const options = getRenderOptions();
    const inputEle = form.elements.q;
    const noHitsEle = el('div.r-pam.t4.centerify', null, 'Ingen treff');

    const bapOpenFiltersOverlayEnabled = form.hasAttribute('data-bap-open-filters-overlay-enabled');

    let req;
    let canceler; // XHR abort
    let dropdownEle;
    let lastTerm = '';
    const items = [];

    inputEle.addEventListener('input', trackInput);

    let suggestionsDropdown;
    if ('EventSource' in window) {
        suggestionsDropdown = new SuggestionsDropdown(inputEle, streamFetch, streamAbort, options);

        // Buffer the streaming results to avoid re-rendering too often
        render = throttle(render, 50);
    } else {
        suggestionsDropdown = new SuggestionsDropdown(inputEle, fetch, abort, options);
    }

    if (isGlobal) {
        inputEle.selectionStart = inputEle.value.length;
        suggestionsDropdown.fetch(inputEle.value, suggestionsDropdown.show);
    }

    function streamFetch (term, onsuccess) {
        // if (term.trim() == lastTerm.trim()) {
        //     return;
        // }
        lastTerm = term;

        streamAbort();

        const url = createFetchUrl(streamingSuggestUrl, term);

        try {
            req = new EventSource(url, { withCredentials: true });
        } catch (e) { // e.g. no CORS
            suggestionsDropdown.fetch = fetch;
            suggestionsDropdown.abort = abort;
            fetch(term, onsuccess);
            return;
        }

        req.addEventListener('message', (e) => {
            if (e.data === '') {
                if (items.length === 0) {
                    handleEmptyResult();
                }
                streamAbort();
                return;
            }

            try {
                items.push(JSON.parse(e.data));
            } catch (e) {
                return;
            }

            if (isGlobal) {
                noHitsEle.remove();
            }
            const groups = groupItems(items);
            sortResultsInGroups(groups);
            sortGroups(groups);
            render(groups, onsuccess);
        });
    }

    function fetch (term, onsuccess) {
        // if (term.trim() == lastTerm.trim()) {
        //     return;
        // }
        lastTerm = term;

        abort();

        const xhr = new XMLHttpRequest();

        xhr.open('GET', createFetchUrl(suggestUrl, term));
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.withCredentials = true;
        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE && xhr.responseText) {
                const items = JSON.parse(xhr.responseText);

                if (items.length === 0) {
                    handleEmptyResult();
                } else {
                    if (isGlobal) {
                        noHitsEle.remove();
                    }
                    const groups = groupItems(items);
                    sortResultsInGroups(groups);
                    sortGroups(groups);
                    render(groups, onsuccess);
                }
            }
        };

        xhr.send();

        canceler = () => xhr.abort();
    }

    function createFetchUrl (base, term) {
        const url = new URL(base);

        url.searchParams.set('dropdown', !isGlobal);
        url.searchParams.set('searchKeys', searchKeys);
        url.searchParams.set('client', client);
        url.searchParams.set('beta', beta);
        url.searchParams.set('where', where);
        url.searchParams.set('term', term);

        return url.href;
    }

    function handleEmptyResult () {
        suggestionsDropdown.hide();
        if (isGlobal) {
            form.querySelector('[data-dropdown-insertion]').append(noHitsEle);
        }
    }

    function streamAbort () {
        if (req) {
            req.close();
            reset();
        }
    }

    function abort () {
        if (canceler) {
            canceler();
            reset();
            canceler = null;
        }
    }

    function reset () {
        req = null;
        if (items.length > 0) {
            setStatus(`${items.length} forslag`);
            items.length = 0;
        }
        hideSpinner();
    }

    function setStatus (text) {
        if (suggestionsDropdown.setStatus) {
            suggestionsDropdown.setStatus(text);
        }
    }

    function groupItems (items) {
        const groups = [];
        items.forEach((item) => {
            let group = groups.filter((group) => group.groupingHeader === item.groupingHeader)[0];
            if (!group) {
                group = {
                    type: item.resultType,
                    groupingHeader: item.groupingHeader,
                    description: item.groupingHeader,
                    groupOrder: item.groupOrder,
                    itemOrder: item.itemOrder,
                    results: [],
                };
                groups.push(group);
            }

            const linkExists = group.results.some((result) => result.url && item.url &&
            result.url.toLowerCase() === item.url.toLowerCase());

            // We only display one item with the same title in a group
            if (!linkExists) {
                group.results.push(item);
            }
        });
        return groups;
    }

    function sortGroups (groups) {
        groups.sort((a, b) => b.groupOrder - a.groupOrder);
    }

    function sortResultsInGroups (groups) {
        groups.forEach((group) => {
            group.results.sort((a, b) => b.itemOrder - a.itemOrder);
        });
    }

    function render (groups, onsuccess) {
        dropdownEle = el('div.t4', null, groups.map(renderGroupData));
        dropdownEle.classList.toggle('dropdown', isDropdown);
        dropdownEle.addEventListener('touchmove', () => {
            inputEle.blur();
        });
        onsuccess(dropdownEle);
        if (items.length === 0) {
            setStatus(`${groups.map((group) => group.results.length).reduce((a, b) => a + b, 0)} forslag`);
        }
    }

    function renderGroupData (group) {
        if (where === 'BROWSE') {
            switch (group.type) {
                case 'COMPANYPROFILE':
                    return renderGroupCompanyProfile(group);

                case 'SEARCH_FINN':
                    return renderGroupSearchFinn(group);

                case 'AD':
                    return renderGroupAd(group);

                default:
                    return renderGroup(group);
            }
        }

        switch (group.type) {
            case 'AD':
                return renderGroupAd(group);

            case 'COMMAND':
                return renderGroupCommand(group);

            case 'SEARCH_FINN':
                return renderGroupSearchFinn(group);

            default:
                return renderGroup(group);
        }
    }

    function renderGroup (group) {
        return el('div.dropdown-section.r-pvm', { 'data-group-type': group.type },
            el('h2.man.dropdown-heading.phs.truncate.licorice', null, group.description),
            // role=presentation here is because of a VoiceOver bug which doesn't read items unless we do this
            el('ol.man.dropdown-result-list', { role: 'presentation' },
                group.results.map(renderResult)
            )
        );
    }

    function renderResult (result, index) {
        const title = [];
        if (result.titleSupplement) {
            if (result.title) {
                if (result.secondaryTitle) {
                    title.push(result.secondaryTitle, '–');
                }
                title.push(result.titleSupplement, result.title);
            } else {
                title.push(result.titleSupplement);
                if (result.secondaryTitle) {
                    title.push(result.secondaryTitle);
                }
            }
        } else if (result.title) {
            if (result.secondaryTitle) {
                title.push(result.secondaryTitle, '–');
            }
            title.push(result.title);
        } else if (result.secondaryTitle) {
            title.push(result.secondaryTitle);
        }
        const ariaTitle = [
            result.groupingHeader,
            title.join(' '),
            result.info1,
            result.info2,
        ].filter((v) => v != null).join(', ');
        return el('li.phs.dropdown-item', { 'aria-label': ariaTitle },
            el('a.dropdown-link', {
                'href': result.url,
                'data-automation-id': 'global_search_suggestion',
                'data-group-index': index,
                'data-track': JSON.stringify(result.data.track),
                'aria-label': ariaTitle,
            },
                renderTitle(result.title, result.titleSupplement, result.secondaryTitle),
                (result.info1 ? renderInfo1(result.info1) : null),
                ' ',
                (result.info2 ? renderInfo2(result.info2) : null)
            )
        );
    }

    function renderGroupAd (group) {
        return el('div.dropdown-section.r-pvm', { 'data-group-type': group.type },
            el('ol.man.dropdown-result-list', { role: 'presentation', style: 'width: 100%' },
                group.results.map(renderResultAd)
            )
        );
    }

    function renderResultAd (result, index) {
        return el('li.phs.dropdown-item', null,
            el('a.dropdown-link.dropdown-link-ad', {
                'href': result.url,
                'data-automation-id': 'global_search_suggestion',
                'data-group-index': index,
                'data-choose-me': result.chooseMe,
                'data-track': JSON.stringify(result.data.track),
            },
                el('div.autocomplete-result-image.flex-no-shrink.mvt', null,
                    el('img.blockify', {
                        src: result.imgUrl.replace(/\/mmo\/|\/dynamic\/default\//, '/dynamic/300x225c/'),
                        width: '100',
                        height: '75',
                    }
                    )
                ),
                el('div.autocomplete-result-text.plm.truncate', null,
                    renderTitle(result.title, result.titleSupplement),
                    renderInfo1(result.info1)
                )
            )
        );
    }

    function renderGroupCompanyProfile (group) {
        const groupingHeader = group.groupingHeader ? group.groupingHeader : 'Bedriftsprofiler';
        return el('div.dropdown-section.r-pvm', { 'data-group-type': group.type },
            el('h2.man.dropdown-heading.phs.truncate.licorice', null, groupingHeader),
            el('ol.man.dropdown-result-list', { role: 'presentation', style: 'width: 100%' },
                group.results.map(renderResultCompanyProfile)
            )
        );
    }

    function renderResultCompanyProfile (result, index) {
        return el('li.phs.dropdown-item', null,
            el('a.dropdown-link.dropdown-link-ad', {
                'href': result.url,
                'data-group-index': index,
                'data-track': JSON.stringify(result.data.track),
            },
                el('div.autocomplete-result-image.flex-no-shrink.bat.mvt.relative',
                    { style: 'width: 100px; height: 75px; background: #fff;' },
                    el('img.blockify.centered-element', {
                        src: result.imgUrl.replace('640w', '240w'),
                        style: 'max-height: 100%; padding: 5px;',
                    }
                    )
                ),
                el('div.autocomplete-result-text.plm.truncate', null,
                    renderTitle(result.title, result.titleSupplement),
                    result.info1 ? renderInfo1(result.info1) : null,
                    result.info2 ? renderInfo2(result.info2) : null
                )
            )
        );
    }

    function renderGroupCommand (group) {
        return el('div.dropdown-section.r-pvm', null, [
            el('h2.man.dropdown-heading.phs.truncate.licorice', null, group.description),
            el('ol.man.dropdown-result-list', { role: 'presentation' },
                group.results.map(renderResultCommand)
            ),
        ]);
    }

    function renderResultCommand (result) {
        return el('li.phs.truncate.dropdown-item', null,
            renderTitle(result.title, result.titleSupplement),
            renderInfo1(result.info1)
        );
    }

    function renderGroupSearchFinn (group) {
        return el('div.dropdown-section.r-pvm', { 'data-group-type': group.type },
            el('ol.man.dropdown-result-list', { role: 'presentation' },
                group.results.map(renderResultSearchFinn)
            )
        );
    }

    function renderResultSearchFinn (result, index) {
        const url = new URL(result.url);
        return el('li.phs.dropdown-item', null,
            el('a.dropdown-link', {
                'href': url.href,
                'data-group-index': index,
                'data-track': JSON.stringify(result.data.track),
            },
                el('svg:svg.valign-middle', { width: '18', height: '18', viewBox: '19.5 119.5 62 62' },
                    el('svg:path', {
                        d: 'M65.8 146.083c0-10.823-8.778-19.6-19.616-19.6-10.83 0-19.614 8.776-19.614 19.6 0 ' +
                        '10.84 8.784 19.616 19.614 19.616 10.837 0 19.615-8.778 19.615-19.617z',
                        fill: 'none',
                    }),
                    el('svg:path', {
                        d: 'M80.982 175.818l-13.92-13.924c3.336-4.393 5.316-9.867 5.316-15.812 0-14.457-11.725' +
                        '-26.177-26.195-26.177-14.457 0-26.184 11.72-26.184 26.177 0 14.472 11.726 26.196 ' +
                        '26.183 26.196 5.93 0 11.408-1.983 15.794-5.307L75.9 180.894l5.082-5.075zM26.57 ' +
                        '146.083c0-10.823 8.784-19.6 19.614-19.6 10.835 0 19.615 8.776 19.615 19.6 0 ' +
                        '10.84-8.778 19.616-19.616 19.616-10.83 0-19.614-8.778-19.614-19.617z',
                        fill: '#9ba8b1',
                    })
                ),
                ' ',
                el('span.valign-middle.autocomplete-result-text.licorice', { 'data-title': '' },
                    renderHighlightedTerm(result.titleSupplement)
                )
            )
        );
    }

    function renderTitle (text, prefix, secondaryTitle) {
        text = text || '';
        if (prefix) {
            return el('span.licorice', { 'title': prefix + text, 'data-title': '' },
                renderHighlightedTerm(prefix),
                text ? renderMainTitle(text, secondaryTitle) : null
            );
        }
        return el('span', { 'title': (secondaryTitle ? secondaryTitle + (text ? ' – ' : '') : '') + text, 'data-title': '' },
            secondaryTitle ? secondaryTitle + (text ? ' – ' : '') : null,
            text
        );
    }

    function renderMainTitle (text, secondaryTitle) {
        const mainTitle = (secondaryTitle ? `${secondaryTitle} – ` : '') + text;
        return el('span.primary-blue', null, mainTitle);
    }

    function renderInfo1 (text) {
        return el('p.man.licorice.smalltext.truncate', { title: text },
            renderHighlightedTerm(text)
        );
    }

    function renderInfo2 (text) {
        return el('span.licorice.smalltext', null, text);
    }

    function renderHighlightedTerm (text) {
        // Turn "Term Term1 " into /(^|\s)(Term1|Term)/, the terms being escaped.
        // `(^|\s)` is added to only highlight beginning of words.
        const pattern =
            `(^|\\s)(${
                lastTerm.trim()
                    .split(/\s+/)
                    // Sort by length (longest first) since the matching is eager, e.g.:
                    //  Bad:  "t t1".match(/t|t1/gi) -> ["t", "t"]
                    //  Good: "t t1".match(/t1|t/gi) -> ["t", "t1"]
                    .sort((term1, term2) => term2.length - term1.length)
                    .map(escapeRegExp)
                    .join('|')
                })`;
        const termsRegExp = new RegExp(pattern, 'gi');
        let termsToHighlight = text.match(termsRegExp);
        if (!termsToHighlight) {
            return [text];
        }

        termsToHighlight = termsToHighlight.map(s => s.trim()); // some matches might include whitespace

        return text
            .split(termsRegExp)
            .filter(Boolean)
            .reduce((prev, curr) => prev.concat(termsToHighlight.indexOf(curr) === -1 ? curr : el('b', null, curr)), []);
    }

    function getRenderOptions () {
        return {
            updateValue: false,
            hideOnDeactivation: isDropdown,
            selectedClass: 'bg-ice',
            dropdownClass: 'dropdown-container',
            insertionElement: form.querySelector('[data-dropdown-insertion]'),
            timeout: 0,
            onsubmit (item, ele) {
                if (!item || item.length < 1) {
                    return;
                }

                if (!dropdownEle) {
                    form.submit();
                    return;
                }

                const chooseMeEle = dropdownEle.querySelector('[data-choose-me]');
                if (!ele && chooseMeEle) {
                    trackPickedItem(dropdownEle, chooseMeEle);
                    trackViewedItems(dropdownEle);
                    const url = new URL(chooseMeEle.href);
                    if (bapOpenFiltersOverlayEnabled) {
                        url.searchParams.set('filters', '');
                    }
                    window.location = url.href;
                    return true;
                }

                const a = ele && ele.querySelector('a');
                if (a && a.href) {
                    trackPickedItem(dropdownEle, a);
                    trackViewedItems(dropdownEle);
                    const url = new URL(a.href);
                    if (bapOpenFiltersOverlayEnabled) {
                        url.searchParams.set('filters', '');
                    }
                    window.location = url.href;
                    return true;
                }

                trackSubmit();
                form.submit();
            },
            onclose () {
                if (render.cancel) {
                    render.cancel();
                }
            },
            contentGetter (ele) {
                return (ele.querySelector('[data-title]') || ele).textContent;
            },
        };
    }

    function hideSpinner () {
        if (spinnerEle) {
            spinnerEle.remove();
        }
    }

    function trackSubmit () {
        tracking.trackEventLater({
            analyticsName: 'search.search-for-something.executed',
            eventFlags: 'success',
            stringValue: `${getTrackingLocation(where, searchKeys)},type:freetext`,
        });
    }

    function trackInput (event) {
        tracking.trackEvent({
            analyticsName: 'search.search-for-something.typed',
            eventFlags: 'start',
            stringValue: getTrackingLocation(where, searchKeys),
        });
        event.target.removeEventListener('input', trackInput);
    }

    function trackPickedItem (dropdownEle, ele) {
        const index = Array.from(dropdownEle.querySelectorAll('[data-track]')).indexOf(ele);
        const data = JSON.parse(ele.getAttribute('data-track'));
        const groupIndex = JSON.parse(ele.getAttribute('data-group-index'));
        data['searchfront.index'] = index + 1;
        data['searchfront.groupindex'] = parseInt(groupIndex) + 1;
        tracking.trackEventLater({
            analyticsName: 'search.search-for-something.dropdown-item-picked',
            eventFlags: 'success',
            numberValue: index + 1,
            stringValue: `${getTrackingLocation(where, searchKeys)},type:${data['searchfront.type']}`,
        });
        tracking.trackEventLater({
            ecType: 'SEARCH',
            ecCategory: 'searchfront.click',
            eventData: data,
        });
    }

    function trackViewedItems (ele) {
        const itemEles = ele.querySelectorAll('[data-track]');
        Array.from(itemEles).forEach((itemEle, i) => {
            const data = JSON.parse(itemEle.getAttribute('data-track'));
            data['searchfront.index'] = i + 1;
            const groupIndex = itemEle.getAttribute('data-group-index');
            data['searchfront.groupindex'] = parseInt(groupIndex) + 1;
            tracking.trackEventLater({
                ecType: 'SEARCH',
                ecCategory: 'searchfront.view',
                eventData: data,
            });
        });
    }

    function getTrackingLocation (where, searchKeys) {
        if (searchKeys === 'SEARCH_ID_JOB_FULLTIME') {
            return 'location:jobfront';
        } else if (searchKeys === 'SEARCH_ID_BAP_ALL') {
            return 'location:bapfront';
        }
        return `location:${where.toLowerCase()}`;
    }

    /* eslint-disable */
    // https://remysharp.com/2010/07/21/throttling-function-calls
    function throttle(fn, threshhold, scope) {
        threshhold || (threshhold = 250);
        var last,
            deferTimer;

        var throttledFunction = function() {
            var context = scope || this;

            var now = +new Date(),
                args = arguments;
            if (last && now < last + threshhold) {
                // hold on to it
                clearTimeout(deferTimer);
                deferTimer = setTimeout(function() {
                    last = now;
                    fn.apply(context, args);
                }, threshhold);
            } else {
                last = now;
                deferTimer = setTimeout(function() {
                    fn.apply(context, args);
                }, threshhold);
            }
        };

        throttledFunction.cancel = function() {
            clearTimeout(deferTimer);
        };

        return throttledFunction;
    }

    function escapeRegExp (s) {
        // https://github.com/benjamingr/RegExp.escape/blob/master/polyfill.js
        return String(s).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    /* eslint-enable */
}



// WEBPACK FOOTER //
// frontpage-search.js